import { render, staticRenderFns } from "./SyncNavBarList.vue?vue&type=template&id=56905153&scoped=true&"
import script from "./SyncNavBarList.vue?vue&type=script&lang=js&"
export * from "./SyncNavBarList.vue?vue&type=script&lang=js&"
import style0 from "./SyncNavBarList.vue?vue&type=style&index=0&id=56905153&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56905153",
  null
  
)

export default component.exports